import React, {useState} from 'react';
import { classNames } from '../../Services/helpers';
import TimeAgo from '../Formatting/TimeAgo';
import Icon from '../Icons/Icon';
import NotificationLog from './NotificationLog';
import Broadcast from './Broadcast';
import Preview from '../Gallery/Preview';
import { NoValue } from '@/Components/Primitives';

const Message = ({message, isLast, nextIsSameDirection, fullWidth, refreshThread}) => {
    const [showTimestamp, setShowTimestamp] = useState(false);

    if (!message) {
        return <NoValue />;
    }

    if (message.journalId) {
        return <NotificationLog log={message} refreshThread={refreshThread} />
    }

    if (message.broadcastId) {
        return <Broadcast message={message} />
    }

    const { content, direction, sentAt, seenByContactAt, assetIds } = message;

    return <div className={(nextIsSameDirection || assetIds) ? 'mb-1' : 'mb-3'}>
        <div className={classNames(
                'rounded-xl py-2 px-3',
                assetIds && 'mb-1',
                fullWidth ? 'w-full' : 'max-w-[85%]',
                direction === 'Outbound' && 'place-self-end rounded-br-none surface-3',
                direction === 'Inbound' && 'place-self-start rounded-bl-none surface-4'
            )}
            onClick={() => setShowTimestamp(!showTimestamp)}
        >
            <p>{content}</p>
            {(isLast || showTimestamp) && <p className={classNames('text-xs', direction === 'Outbound' ? 'text-muted' : 'text-slate-200')}>
                <TimeAgo dateTime={sentAt} />
                {(direction === 'Outbound' && seenByContactAt) && <span className="ml-2">
                    <Icon icon="Check" size="0.5x" className="fill-brand" inline />
                </span>}
            </p>}
        </div>
        {assetIds && <Preview assetIds={assetIds} align={direction === 'Inbound' ? 'left' : 'right'} />}
    </div>
}

export default Message;
